var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuperorganisation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7501 10.35C13.5115 10.35 15.7501 8.20097 15.7501 5.55C15.7501 2.89903 13.5115 0.75 10.7501 0.75C7.98867 0.75 5.75009 2.89903 5.75009 5.55C5.75009 8.20097 7.98867 10.35 10.7501 10.35Z",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7501 19.35C20.7501 22.332 20.7501 24.75 10.7501 24.75C0.750092 24.75 0.750092 22.332 0.750092 19.35C0.750092 16.368 5.22759 13.95 10.7501 13.95C16.2726 13.95 20.7501 16.368 20.7501 19.35Z",
    stroke: "black",
    strokeOpacity: 0.6,
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuperorganisation);
export default __webpack_public_path__ + "static/media/superorganisation.fcb02361dcfb6f625a71b283bf231d7f.svg";
export { ForwardRef as ReactComponent };